import { Typography } from "@vaporfi/uikit";
import { numberToAbbreviation } from "@vaporfi/utils";

interface StatCardProps {
	label: string;
	value: string;
}

const StatCard: React.FC<StatCardProps> = ({ label, value }) => (
	<div className="flex flex-col rounded-lg bg-neutral-800 px-4 py-2">
		<Typography size="sm" className="text-neutral-400 whitespace-nowrap">
			{label}
		</Typography>
		<Typography size="lg" weight="semibold" className="text-white">
			{value}
		</Typography>
	</div>
);

interface PoolHeaderStatsProps {
	totalValueLocked: number;
}

export const PoolHeaderStats: React.FC<PoolHeaderStatsProps> = ({
	totalValueLocked,
}) => {
	return (
		<div className="flex items-center gap-4">
			<StatCard
				label="Total Value Locked"
				value={
					!totalValueLocked
						? "$0.00"
						: `$${numberToAbbreviation(totalValueLocked)}`
				}
			/>
		</div>
	);
};

export default PoolHeaderStats;
